import request from './request'
import type { UploadImageResult, UploadImagesResult } from '@/types/upload'

/**
 * 上传单张图片
 * @param file 图片文件
 * @param folder 存储目录，为空时默认 common
 * 注意：folder 必须走 query string——multer 的 destination 回调在解析到文件字段时立即执行，
 * 若 folder 作为文本字段排在文件后面，此时 req.body.folder 还是 undefined，图片会错误落进 common
 */
export function uploadImage(file: File, folder?: string) {
  const formData = new FormData()
  formData.append('file', file)
  if (folder) formData.append('folder', folder)
  const qs = folder ? `?folder=${encodeURIComponent(folder)}` : ''
  return request.post<UploadImageResult>(`/upload/image${qs}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 通过链接上传图片（后端下载远程图片保存到服务器）
 * @param url 图片链接（http/https）
 * @param folder 存储目录，为空时默认 common
 */
export function uploadImageFromUrl(url: string, folder?: string) {
  return request.post<UploadImageResult>('/upload/image-from-url', { url, folder })
}

/**
 * 批量上传图片
 * @param files 图片文件数组
 * @param folder 存储目录，为空时默认 common
 */
export function uploadImages(files: File[], folder?: string) {
  const formData = new FormData()
  files.forEach(file => formData.append('files', file))
  if (folder) formData.append('folder', folder)
  const qs = folder ? `?folder=${encodeURIComponent(folder)}` : ''
  return request.post<UploadImagesResult>(`/upload/images${qs}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
